// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25344
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25344 
import { eventTrackingUtils } from '@/utils/eventTrackingUtils'
export const PageId = Object.freeze({
  OrderCenter_Detail: 'OrderCenter_Detail'
})

interface IPVTrackParamsRecord {
  /** 订单详情页 */
OrderCenter_Detail: undefined
}

const sendPv = {
  /** PV-订单详情页 */
OrderCenter_Detail: () => {
    eventTrackingUtils.submitPV({page_id:PageId.OrderCenter_Detail});
  },
}

interface IExpoTrackParamsRecord {
  /** 取消按钮曝光 */
Orderdetail_CancelExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 取消订单弹窗曝光 */
OrderDetail_CancelPopExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 取消原因弹层曝光 */
OrderDetail_CancelLayerExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 商品总价_价格项箭头曝光 */
Orderdetail_PriceItemArrowExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 删除订单按钮曝光 */
Orderdetail_DeleteExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 删除订单弹窗曝光 */
Orderdetail_DeletePopExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 发票服务按钮曝光 */
OrderDetail_InvoiceServiceExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 立即支付按钮曝光 */
OrderDetail_PayNowExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 再次购买按钮曝光 */
OrderDetail_BuyAgainExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 退款详情页按钮曝光 */
OrderDetail_RefundDetailExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 订单退款按钮曝光 */
Orderdetail_OrderRefundExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 评价按钮曝光 */
OrderDetail_ReviewExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 已完成订单售后进度按钮曝光 */
OrderDetail_AftersaleDetailExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 商品id  */
skuid: string}
  /** 已完成订单商品退款按钮曝光 */
OrderDetail_RefundItemExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 商品id  */
skuid: string}
  /** 已完成订单商品加车按钮曝光 */
OrderDetail_AddtoCartExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 商品id  */
skuid: string}
  /** 订单跟踪按钮曝光 */
Orderdetail_OrderTrackExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 订单详情页订单状态虚拟PV */
Orderdetail_OrderStatusPV: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 复制订单号按钮曝光 */
Orderdetail_DetailCopyExpo: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 最新物流入口曝光 */
Orderdetail_LatestTrackExpo: {
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 订单id  */
orderId: string,
/** 包裹数量  */
packageNum: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 取消按钮曝光 */
  Orderdetail_CancelExpo:'Orderdetail_CancelExpo',
/** 取消订单弹窗曝光 */
  OrderDetail_CancelPopExpo:'OrderDetail_CancelPopExpo',
/** 取消原因弹层曝光 */
  OrderDetail_CancelLayerExpo:'OrderDetail_CancelLayerExpo',
/** 商品总价_价格项箭头曝光 */
  Orderdetail_PriceItemArrowExpo:'Orderdetail_PriceItemArrowExpo',
/** 删除订单按钮曝光 */
  Orderdetail_DeleteExpo:'Orderdetail_DeleteExpo',
/** 删除订单弹窗曝光 */
  Orderdetail_DeletePopExpo:'Orderdetail_DeletePopExpo',
/** 发票服务按钮曝光 */
  OrderDetail_InvoiceServiceExpo:'OrderDetail_InvoiceServiceExpo',
/** 立即支付按钮曝光 */
  OrderDetail_PayNowExpo:'OrderDetail_PayNowExpo',
/** 再次购买按钮曝光 */
  OrderDetail_BuyAgainExpo:'OrderDetail_BuyAgainExpo',
/** 退款详情页按钮曝光 */
  OrderDetail_RefundDetailExpo:'OrderDetail_RefundDetailExpo',
/** 订单退款按钮曝光 */
  Orderdetail_OrderRefundExpo:'Orderdetail_OrderRefundExpo',
/** 评价按钮曝光 */
  OrderDetail_ReviewExpo:'OrderDetail_ReviewExpo',
/** 已完成订单售后进度按钮曝光 */
  OrderDetail_AftersaleDetailExpo:'OrderDetail_AftersaleDetailExpo',
/** 已完成订单商品退款按钮曝光 */
  OrderDetail_RefundItemExpo:'OrderDetail_RefundItemExpo',
/** 已完成订单商品加车按钮曝光 */
  OrderDetail_AddtoCartExpo:'OrderDetail_AddtoCartExpo',
/** 订单跟踪按钮曝光 */
  Orderdetail_OrderTrackExpo:'Orderdetail_OrderTrackExpo',
/** 订单详情页订单状态虚拟PV */
  Orderdetail_OrderStatusPV:'Orderdetail_OrderStatusPV',
/** 复制订单号按钮曝光 */
  Orderdetail_DetailCopyExpo:'Orderdetail_DetailCopyExpo',
/** 最新物流入口曝光 */
  Orderdetail_LatestTrackExpo:'Orderdetail_LatestTrackExpo',
})

interface IClickTrackParamsRecord {
  /** 取消按钮 */
Orderdetail_Cancel: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 不取消按钮(取消订单弹窗) */
OrderDetail_NoCancel: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 确认取消按钮(取消订单弹窗) */
OrderDetail_ComfirmCancel: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 取消原因选择 */
OrderDetail_CancelLayer_SelectReason: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 取消原因  */
cancelreason: string}
  /** 取消原因提交 */
OrderDetail_CancelLayer_SubmitReason: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 取消原因  */
cancelreason: string}
  /** 取消原因弹层关闭 */
OrderDetail_CancelLayer_Close: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 商品总价_价格项箭头点击 */
Orderdetail_PriceItemArrow: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 点击后展开收起状态 0-收起,1-展开 */
isunfold: | '0'| '1'}
  /** 复制订单号 */
Orderdetail_DetailCopy: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 删除订单按钮 */
Orderdetail_Delete: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 取消删除按钮(删除订单弹窗) */
Orderdetail_CancelDelete: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 确认删除按钮(删除订单弹窗) */
Orderdetail_ComfirmDelete: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 订单跟踪按钮 */
Orderdetail_OrderTrack: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 发票服务按钮 */
OrderDetail_InvoiceService: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 立即支付按钮 */
OrderDetail_PayNow: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 再次购买按钮 */
OrderDetail_BuyAgain: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 退款详情按钮 */
OrderDetail_RefundDetail: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 订单退款按钮 */
Orderdetail_OrderRefund: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 评价按钮 */
OrderDetail_Review: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 更多 */
OrderDetail_More: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 已完成订单售后进度按钮 */
OrderDetail_AftersaleDetail: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5'}
  /** 已完成订单商品退款按钮 */
OrderDetail_RefundItem: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 商品id  */
skuid: string}
  /** 已完成订单商品加车按钮 */
OrderDetail_AddtoCart: {
/** 订单id  */
orderId: string,
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 商品id  */
skuid: string}
  /** 最新物流入口点击 */
Orderdetail_LatestTrack: {
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5',
/** 订单id  */
orderId: string,
/** 包裹数量  */
packageNum: string}
}

const sendClickTrack = {
  /** 点击事件上报-取消按钮 */
Orderdetail_Cancel: (json_param: IClickTrackParamsRecord['Orderdetail_Cancel']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_Cancel',json_param});
  },
  /** 点击事件上报-不取消按钮(取消订单弹窗) */
OrderDetail_NoCancel: (json_param: IClickTrackParamsRecord['OrderDetail_NoCancel']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_NoCancel',json_param});
  },
  /** 点击事件上报-确认取消按钮(取消订单弹窗) */
OrderDetail_ComfirmCancel: (json_param: IClickTrackParamsRecord['OrderDetail_ComfirmCancel']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_ComfirmCancel',json_param});
  },
  /** 点击事件上报-取消原因选择 */
OrderDetail_CancelLayer_SelectReason: (json_param: IClickTrackParamsRecord['OrderDetail_CancelLayer_SelectReason']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_CancelLayer_SelectReason',json_param});
  },
  /** 点击事件上报-取消原因提交 */
OrderDetail_CancelLayer_SubmitReason: (json_param: IClickTrackParamsRecord['OrderDetail_CancelLayer_SubmitReason']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_CancelLayer_SubmitReason',json_param});
  },
  /** 点击事件上报-取消原因弹层关闭 */
OrderDetail_CancelLayer_Close: (json_param: IClickTrackParamsRecord['OrderDetail_CancelLayer_Close']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_CancelLayer_Close',json_param});
  },
  /** 点击事件上报-商品总价_价格项箭头点击 */
Orderdetail_PriceItemArrow: (json_param: IClickTrackParamsRecord['Orderdetail_PriceItemArrow']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_PriceItemArrow',json_param});
  },
  /** 点击事件上报-复制订单号 */
Orderdetail_DetailCopy: (json_param: IClickTrackParamsRecord['Orderdetail_DetailCopy']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_DetailCopy',json_param});
  },
  /** 点击事件上报-删除订单按钮 */
Orderdetail_Delete: (json_param: IClickTrackParamsRecord['Orderdetail_Delete']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_Delete',json_param});
  },
  /** 点击事件上报-取消删除按钮(删除订单弹窗) */
Orderdetail_CancelDelete: (json_param: IClickTrackParamsRecord['Orderdetail_CancelDelete']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_CancelDelete',json_param});
  },
  /** 点击事件上报-确认删除按钮(删除订单弹窗) */
Orderdetail_ComfirmDelete: (json_param: IClickTrackParamsRecord['Orderdetail_ComfirmDelete']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_ComfirmDelete',json_param});
  },
  /** 点击事件上报-订单跟踪按钮 */
Orderdetail_OrderTrack: (json_param: IClickTrackParamsRecord['Orderdetail_OrderTrack']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_OrderTrack',json_param});
  },
  /** 点击事件上报-发票服务按钮 */
OrderDetail_InvoiceService: (json_param: IClickTrackParamsRecord['OrderDetail_InvoiceService']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_InvoiceService',json_param});
  },
  /** 点击事件上报-立即支付按钮 */
OrderDetail_PayNow: (json_param: IClickTrackParamsRecord['OrderDetail_PayNow']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_PayNow',json_param});
  },
  /** 点击事件上报-再次购买按钮 */
OrderDetail_BuyAgain: (json_param: IClickTrackParamsRecord['OrderDetail_BuyAgain']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_BuyAgain',json_param});
  },
  /** 点击事件上报-退款详情按钮 */
OrderDetail_RefundDetail: (json_param: IClickTrackParamsRecord['OrderDetail_RefundDetail']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_RefundDetail',json_param});
  },
  /** 点击事件上报-订单退款按钮 */
Orderdetail_OrderRefund: (json_param: IClickTrackParamsRecord['Orderdetail_OrderRefund']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_OrderRefund',json_param});
  },
  /** 点击事件上报-评价按钮 */
OrderDetail_Review: (json_param: IClickTrackParamsRecord['OrderDetail_Review']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_Review',json_param});
  },
  /** 点击事件上报-更多 */
OrderDetail_More: (json_param: IClickTrackParamsRecord['OrderDetail_More']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_More',json_param});
  },
  /** 点击事件上报-已完成订单售后进度按钮 */
OrderDetail_AftersaleDetail: (json_param: IClickTrackParamsRecord['OrderDetail_AftersaleDetail']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_AftersaleDetail',json_param});
  },
  /** 点击事件上报-已完成订单商品退款按钮 */
OrderDetail_RefundItem: (json_param: IClickTrackParamsRecord['OrderDetail_RefundItem']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_RefundItem',json_param});
  },
  /** 点击事件上报-已完成订单商品加车按钮 */
OrderDetail_AddtoCart: (json_param: IClickTrackParamsRecord['OrderDetail_AddtoCart']) => {
    eventTrackingUtils.submitCL({event_id:'OrderDetail_AddtoCart',json_param});
  },
  /** 点击事件上报-最新物流入口点击 */
Orderdetail_LatestTrack: (json_param: IClickTrackParamsRecord['Orderdetail_LatestTrack']) => {
    eventTrackingUtils.submitCL({event_id:'Orderdetail_LatestTrack',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}